module.exports = __webpack_public_path__ + "static/media/table-view.4f1498a3.svg";